module.exports = __webpack_public_path__ + "img/2.e4c9dbf4.jpg";